import styles from './OverlayContent.module.scss';
import React, { useState } from 'react';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
  InputField,
  Link,
  List,
  ListItem,
} from '@wienenergiegithub/ui-next';
import { Form, FormSubmit } from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const OverlayContent = ({
  formSuccess,
  linkList,
  mobileDisclosure,
  pageLink,
  setOverlayVisibility,
  store,
}) => {
  const [showEmailField, setShowEmailField] = useState(false);

  return (
    <>
      <Heading as="h2" size="h5">
        Mit Links zum Ziel
      </Heading>
      <Content noSpacing>
        Diese Seiten führen Sie direkt zu den passenden Produkten und Services:
      </Content>

      <div className={styles.linkList}>
        {linkList?.map(({ keyword, label, link }) => (
          <Content key={keyword}>
            <Link to={link}>{label}</Link>
          </Content>
        ))}
      </div>
      <div className={styles.buttonContainer}>
        {!showEmailField && !formSuccess && (
          <Button
            className={styles.fullWidthButton}
            isElevated
            onClick={() => {
              setShowEmailField(true);
            }}
          >
            Ich möchte die Liste PER E-Mail
          </Button>
        )}

        {showEmailField && !formSuccess && (
          <Form className={styles.formContainer} store={store}>
            <InputField
              className={styles.inputEmail}
              label="E-Mail"
              name="email"
              required
              store={store}
              variant="closed"
            />
            <Content className={styles.legalText}>
              Die angegebene E-Mail Adresse wird nicht gespeichert und direkt
              nach der E-Mailversendung gelöscht.
            </Content>
            <FormSubmit
              render={
                <Button className={styles.submitButton} isElevated>
                  Senden
                </Button>
              }
              store={store}
            />
          </Form>
        )}

        {formSuccess && (
          <div className={styles.successContainer}>
            <Heading as="h1" size="h6">
              E-Mail gesendet!
            </Heading>
            <List
              className={styles.list}
              icon={
                <FontAwesomeProIcon
                  icon="check"
                  role="presentation"
                  type="regular"
                />
              }
              noSpacing
              type="checkmark"
            >
              <ListItem
                className={styles.successText}
                data-purpose="success-message"
                variant="contrast"
              >
                Die E-Mail mit Ihrer Link-Liste ist schon unterwegs zu Ihnen.
              </ListItem>
            </List>
            <Content className={styles.legalText}>
              Die angegebene E-Mail Adresse wird nicht gespeichert und direkt
              nach der E-Mailversendung gelöscht.
            </Content>
          </div>
        )}

        {!!pageLink &&
          window.location.href.replace('#business-wizard', '') !==
            pageLink.replace('#business-wizard', '') && (
            <Button
              render={
                <Link
                  className={classNames(
                    styles.fullWidthButton,
                    styles.actionButton,
                  )}
                  to={
                    pageLink?.includes('#business-wizard')
                      ? pageLink
                      : `${pageLink}#business-wizard`
                  }
                >
                  Auswahl ändern
                </Link>
              }
              theme="secondary"
            />
          )}
      </div>
      {mobileDisclosure && (
        <Button
          className={styles.closeButton}
          data-purpose="overlay schließen"
          onClick={() => {
            setOverlayVisibility(false);
          }}
          theme="secondary"
          variant="link"
        >
          Schliessen
        </Button>
      )}
    </>
  );
};

OverlayContent.propTypes = {
  formSuccess: PropTypes.bool,
  linkList: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
    }),
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  mobileDisclosure: PropTypes.object,
  pageLink: PropTypes.string,
  setOverlayVisibility: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
};

export { OverlayContent };
